import React, { useEffect, useState } from 'react';
import Button from '../../components/Button';
import AddDetails from '../studentDetails/AddDetails';
import { Link } from 'react-router-dom';
import DoctorWrapper from '../TeacherWrapper';
import Input from '../../components/Input';

const DoctorDashboard = () => {
  const [open, setOpen] = useState(false);
  const [myStudents, setMyStudents] = useState([]);
  console.log(myStudents);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCourses = myStudents?.filter((course) => {
    const matchesSearchQuery = course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearchQuery;
  });

  const [mytotalCourse, setTotalCourse] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    // Start loading
    setLoading(true);

    fetch(
      `https://quran-backend-theta.vercel.app/v1/teacher/my-students/${data?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setMyStudents(data?.data);
      })
      .catch((error) => console.error(error))
      .finally(() => setLoading(false)); // Stop loading once data is fetched
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/teacher/my-course/${data?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log('Course', data?.data);
        setTotalCourse(data?.data);
      })
      .catch((error) => console.error(error));
  }, []);

  const [tab, setTabs] = useState('assigned');

  return (
    <DoctorWrapper
      searchBar={
        <Input
          placeholder={`Search by  name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <AddDetails setIsModalOpen={setOpen} isModalOpen={open} />
      <div className=" ">
        <h2 className="main_title ">Dashboard</h2>
        <p className=" text-[#1C1D1D]">Here overview of the courses</p>
      </div>

      <section className=" pt-2">
        <div className=" py-4  w-full grid  grid-cols-1  xl:grid-cols-2 md:grid-cols-2 gap-5">
          <div className=" w-full">
            <div
              onClick={() => setTabs('assigned')}
              className="  bg-white p-5 rounded-lg cursor-pointer flex  justify-between"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Assigned Students</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3  text-[#1C1D1D]">{myStudents?.length}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/active.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              onClick={() => setTabs('ongoing')}
              className=" bg-white  flex justify-between cursor-pointer p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Ongoing Cources</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{mytotalCourse?.length}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/completed.png')} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {tab === 'assigned' && (
        <section className="mb-20 mt-7">
          <div className=" flex pb-5  justify-between items-center">
            <h1 className=" text-xl text-[#1C1D1D] font-semibold">My Students</h1>
          </div>
          <div className=" rounded-lg   overflow-x-auto">
            <div className="flex flex-col">
              <div className=" sm:-mx-6 lg:-mx-8 ">
                <div className="inline-block min-w-full sm:px-6 lg:px-8 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead>
                        <tr className=" rounded-lg whitespace-nowrap ">
                        <th scope="col" className=" text-sm   text-primary  font-bold px-6 py-4">
                            Sr No.
                          </th>
                          <th scope="col" className=" text-sm   text-primary  font-bold px-6 py-4">
                            ID
                          </th>
                          <th scope="col" className=" text-sm   text-primary  font-bold px-6 py-4">
                            Name
                          </th>

                          <th scope="col" className=" text-sm text-primary   font-bold px-6 py-4">
                            Father Name
                          </th>

                          <th scope="col" className="text-sm text-primary    font-bold px-6 py-4">
                            Age
                          </th>

                          {/* <th scope="col" className="text-sm text-primary    font-bold px-6 py-4">
                            Address
                          </th> */}

                          <th scope="col" className="text-sm  text-primary    font-bold px-6 py-4">
                            Country
                          </th>
                          <th scope="col" className="text-sm  text-primary    font-bold px-6 py-4">
                            Timing
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Display loading message if data is being fetched */}
                        {loading ? (
                          <tr>
                            <td colSpan="6" className="text-center py-4 text-lg text-gray-500">
                              Loading students...
                            </td>
                          </tr>
                        ) : myStudents?.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center py-4 text-lg text-gray-500">
                              No students found
                            </td>
                          </tr>
                        ) : (
                          myStudents?.map((student,index) => (
                            <tr
                              key={student?._id}
                              className="bg-white border-b-8 border-white rounded-md"
                            >
                              <td className="align-middle whitespace-nowrap bg-white text-sm font-normal px-6 py-4 text-center">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {index+1}
                                </span>
                              </td>
                              <td className="align-middle whitespace-nowrap bg-white text-sm font-normal px-6 py-4 text-center">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {student?.enrollment?.userDetails?.studentId}
                                </span>
                              </td>
                              <td className="align-middle whitespace-nowrap bg-white text-sm font-normal px-6 py-4 text-center">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {student?.enrollment?.studentName}
                                </span>
                              </td>
                              <td className="text-sm whitespace-nowrap bg-white font-normal text-center px-6 py-4">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {student?.enrollment?.fatherName}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 text-left">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {student?.enrollment?.userDetails?.age}
                                </span>
                              </td>
                              {/* <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 text-left">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {student?.enrollment?.userDetails?.address}
                                </span>
                              </td> */}
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 text-left">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {student?.enrollment?.country}
                                </span>
                              </td>
                              <td className="align-middle whitespace-nowrap bg-white text-center text-sm font-normal px-6 py-4 text-left">
                                {student?.timeSlots?.map((item, index) => (
                                  <span
                                    key={index}
                                    className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full"
                                  >
                                    {item?.startTime} - {item?.endTime}
                                  </span>
                                ))}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {tab === 'ongoing' &&
        (loading ? (
          <p>Loading courses...</p>
        ) : (
          <section>
            {mytotalCourse?.length === 0 ? (
              <p>No courses available</p>
            ) : (
              <div className="grid grid-cols-2 mt-4 gap-6">
                {mytotalCourse?.map((course) => (
                  <Link
                    to={`/teacher-cource-details/${course?._id}`}
                    className="bg-white p-5 items-center flex md:flex-row flex-col rounded-lg gap-4"
                    style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                    key={course?._id}
                  >
                    {console.log('My Courses', course?._id)}
                    <div className="w-20 h-20 rounded-lg overflow-hidden">
                      <img src={course?.image} className="w-full h-full" alt={course?.name} />
                    </div>
                    <div>
                      <h6 className="text-lg flex gap-3">
                        {course?.name}{' '}
                        <img src={require('../../assets/image/LockSimple.png')} alt="" />
                      </h6>
                      <div className="flex gap-5 pt-2 items-center">
                        <div className="flex gap-1 items-center">
                          <div>
                            <img src={require('../../assets/image/Clock.png')} alt="" />
                          </div>
                          <p>
                            {course?.duration} {course?.periodType}
                          </p>
                        </div>

                        <div className="flex gap-1 items-center">
                          <p>
                            Status : <span className="text-sm text-[green]">Active</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </section>
        ))}
    </DoctorWrapper>
  );
};

export default DoctorDashboard;
